import manager from 'app/module46/component-manager.js';

manager.register('contact', contact);

/**
 * @param {Element} component
 * @param {Object.<string, Element>} references
 * @param {Object.<string, string>} attributes
 * @param {Object.<string, string>} properties
 */
function contact(component, references, attributes, properties) {
	const {
		callBtn,
		chatBtn
	} = references;

	const {
		createUrl
	} = properties;

	callBtn.addEventListener('click', () => {
		startCommunication(callBtn, 'call');
	});
	chatBtn.addEventListener('click', () => {
		startCommunication(chatBtn, 'chat');
	});

	/**
	 * @param {Element} el
	 * @param {string} type
	 */
	function startCommunication(el, type) {
		if (el.classList.contains('disabled')) {
			return;
		}

		manager.api(createUrl, {
				type,
				screenshot_id: '',
				subject: 'general',
			},
			({ callingId }) => {

				if (callingId) {
					// Send communication id to refresher (flap.js)
					window.setCalling(true, callingId, type);
				}
			}
		);
	}

}
